import { Controller } from "@hotwired/stimulus"
import hljs from "highlight.js/lib/core"
import ruby from "highlight.js/lib/languages/ruby"

hljs.registerLanguage("ruby", ruby)

export default class extends Controller {
  connect() {
    // Standard <pre><code> blocks
    this.element.querySelectorAll("pre code").forEach((block) => {
      block.classList.add("language-ruby")
      hljs.highlightElement(block)
      this.#wrapOperators(block)
      this.#addLineNumbers(block)
    })

    // Trix outputs plain <pre> without a nested <code>
    this.element.querySelectorAll("pre:not(:has(> code))").forEach((pre) => {
      pre.classList.add("language-ruby")
      hljs.highlightElement(pre)
      this.#wrapOperators(pre)
      this.#addLineNumbers(pre)
    })
  }

  // hljs Ruby grammar leaves operators as plain text nodes — wrap them ourselves.
  // We only touch text nodes that are NOT already inside an hljs-* span
  // (so strings, comments, params, etc. are never double-processed).
  #wrapOperators(element) {
    // Compound operators must come before their single-char components
    const OPERATORS = /(<=>|<<=?|>>=?|\*\*|&&|\|\||==|!=|<=|>=|=>|[+\-*\/%<>]|=(?![>=]))/g

    const textNodes = []
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT)
    let node

    while ((node = walker.nextNode())) {
      let inside = false
      let ancestor = node.parentElement
      while (ancestor && ancestor !== element) {
        if (ancestor.className?.includes("hljs-")) { inside = true; break }
        ancestor = ancestor.parentElement
      }
      if (!inside) textNodes.push(node)
    }

    textNodes.forEach(textNode => {
      OPERATORS.lastIndex = 0
      const text = textNode.textContent
      if (!OPERATORS.test(text)) return

      OPERATORS.lastIndex = 0
      const frag = document.createDocumentFragment()
      let last = 0, m

      while ((m = OPERATORS.exec(text)) !== null) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)))
        const span = document.createElement("span")
        span.className = "hljs-operator"
        span.textContent = m[0]
        frag.appendChild(span)
        last = OPERATORS.lastIndex
      }

      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)))
      textNode.replaceWith(frag)
    })
  }

  #addLineNumbers(element) {
    const lines = element.innerHTML.split("\n")
    if (lines.at(-1).trim() === "") lines.pop()
    element.innerHTML = lines
      .map(line => `<span class="code-line">${line || "\u00a0"}</span>`)
      .join("")
  }
}
